







import { Vue, Component, Prop } from 'vue-property-decorator';
import sitemap from '@/sitemap';

@Component({
    name: 'action-header'
})
export default class ActionHeader extends Vue
{
    @Prop({default: false}) private autoHeader: boolean;
    @Prop() private headerTitle: string;
    @Prop() private headerIcon: string;

    private header: any = null;

    created()
    {
        if (this.autoHeader)
        {
            const getHeaderNode = (items: any[], route: string): any =>
            {
                return items.reduce((value: any, item: any) =>
                {
                    if (item && item.route === route)
                    {
                        return item;
                    }
                    if (item && item.children && item.children.length > 0)
                    {
                        return getHeaderNode(item.children, route) || value;
                    }

                    return value;
                },
                null);
            };

            this.header = getHeaderNode(sitemap.items, this.$route.name);
        }
    }

    private get title()
    {
        return this.header ? this.header.name : this.headerTitle;
    }

    private get icon()
    {
        return this.header ? this.header.icon : this.headerIcon;
    }
}
